import { render, staticRenderFns } from "./Alma.vue?vue&type=template&id=16ff0bb3&scoped=true"
import script from "./Alma.vue?vue&type=script&lang=js"
export * from "./Alma.vue?vue&type=script&lang=js"
import style0 from "./Alma.vue?vue&type=style&index=0&id=16ff0bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff0bb3",
  null
  
)

export default component.exports